var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.picture)?_c('img',{staticClass:"media-avatar",attrs:{"src":_vm.picture,"alt":_vm.alt,"onerror":"if (this.src != '/build/v2/img/member/avatar.jpg') this.src = '/build/v2/img/member/avatar.jpg'"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }